/** cloud function api */
const cloudFunctionApi = import.meta.env.REACT_APP_FUNCTIONS_API_URL;
/** fmcg cloud api **/
const fmcgCloudApi = import.meta.env.REACT_APP_FMCG_API_URL;
const cloudV2Api = import.meta.env.REACT_APP_API_V2_URL;
const goApiUrl = import.meta.env.REACT_APP_GO_API_URL;
const fmcgApiAuth = import.meta.env.REACT_APP_FMCG_API_URL_AUTH;
/** nimbly-cloud api */
const nimblyCloudApi = import.meta.env.REACT_APP_CLOUD_API_URL;
const nimblyCloudApiAlt = import.meta.env.REACT_APP_CLOUD_API_URL_ALT;
const nimblyAppengineURL = import.meta.env.REACT_APP_CLOUD_API_APPENGINE_URL;
const nimblyReturnToURL = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_RETURNTO_URL;
const nimblyDashboardID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_OVERVIEW_ID;
const nimblyDashboardIDForDemo = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_OVERVIEW_ID_DEMO;
const nimblyDashboardIDForIssueDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_ISSUE_DASHBOARD_ID;
const nimblyDashboardIDForIssueDashboardDemo = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_ISSUE_DASHBOARD_ID_DEMO;
const nimblyProdOverviewDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_OVERVIEW_ID;
const nimblyProdIssueDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_ISSUE_ID;
const nimblyProdURL = import.meta.env.REACT_APP_PROD_URL;
const nimblyRankingDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_RANKING_DASHBOARD_ID;
const nimblyfnbInsightsDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_FNB_INSIGHTS_DASHBOARD_ID;
const nimblyStorePerformance = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_STORE_PERFORMANCE_DASHBOARD_ID;
const nimblyUsersDashboardID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_USERS_DASHBOARD_ID;
const nimblyProdUserDashboardID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_USERS_DASHBOARD_ID;
const nimblyIRFSATDashboardID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_IRF_SAT_DASHBOARD_ID;
const nimbluIRFSATProdDashboardID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_IRF_SAT_PROD_DASHBOARD_ID;
const nimblyStockAuditDashbaordID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_STOCK_AUDIT_DASHBOARD_ID;
const nimblyStockAuditProdDashboardID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_STOCK_AUDIT_PROD_DASHBOARD_ID;
const nimblySitesDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_SITE_DASHBOARD_ID;
const nimblyJJSitesDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_JANJIJIWA_SITE_DASHBOARD_ID;
const nimnlyProdSitesDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_SITE_DASHBOARD_ID;
const nimnlyProdJJSitesDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_JANJIJIWA_SITE_DASHBOARD_ID;
const nimblyNPSDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_NPS_DASHBOARD_ID;
const nimblyCustomerFeedbackDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_CUSTOMER_FEEDBACK_ID;
const nimblyLmsAdmin = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_LMS_ADMIN;
const nimblyLmsInstructor = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_LMS_INSTRUCTOR;
const nimblyLmsLearner = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_LMS_LEARNER;
const nimblyProdLmsAdmin = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_LMS_ADMIN;
const nimblyProdLmsInstructor = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_LMS_INSTRUCTOR;
const nimblyProdLmsLearner = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_LMS_LEARNER;
const nimblyCustomerMetricsDashboard = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_CUSTOMER_METRICS_DASHBOARD_ID;
const nimblyProdEnv = import.meta.env.REACT_APP_PRODUCTION_ENV;
const nimblyThaiDashboardID = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_THAI_DASHBOARD_ID;
const nimblyKFCOverview = import.meta.env.REACT_APP_KFC_OVERVIEW_DASHBOARD_ID;
const nimblyKFCIssues = import.meta.env.REACT_APP_KFC_ISSUE_DASHBOARD_ID;
const nimblyKFCUsers = import.meta.env.REACT_APP_KFC_USERS_DASHBOARD_ID;
const nimblyKFCSites = import.meta.env.REACT_APP_KFC_SITES_DASHBOARD_ID;
const nimblyPRODKFCOverview = import.meta.env.REACT_APP_KFC_PROD_OVERVIEW_DASHBOARD_ID;
const nimblyPRODKFCIssues = import.meta.env.REACT_APP_KFC_PROD_ISSUE_DASHBOARD_ID;
const nimblyPRODKFCUsers = import.meta.env.REACT_APP_KFC_PROD_USERS_DASHBOARD_ID;
const nimblyPRODKFCSites = import.meta.env.REACT_APP_KFC_PROD_SITES_DASHBOARD_ID;
const nimblyRMUOverview = import.meta.env.REACT_APP_RMU_OVERVIEW_DASHBOARD_ID;
const nimblyProdRMUOverview = import.meta.env.REACT_APP_RMU_PROD_OVERVIEW_DASHBOARD_ID;
const nimblyCEOPersona = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_CEO_PERSONA_DASHBOARD_ID;
const nimblyProdCEOPersona = import.meta.env.REACT_APP_ADVANCED_ANALYTICS_PROD_CEO_PERSONA_DASHBOARD_ID;
const nimblyBulkOpsApiUrl = import.meta.env.REACT_APP_BULK_OPS_API_URL;

const UploadScheduleTemplate = import.meta.env.REACT_APP_SCHEDULE_BULK_UPLOAD_TEMPLATE;
const CreateQuizTemplate = import.meta.env.REACT_APP_LMS_QUIZ_BULK_CREATE_TEMPLATE;
const reportBulkDownload = import.meta.env.REACT_APP_REPORT_BULK_DOWNLOAD;
const nimblyBulkUploadTemplate = import.meta.env.REACT_APP_BULK_UPLOAD_TEMPLATE;

const departmentApi = nimblyCloudApi + '/departments';
const userApi = nimblyCloudApi + '/users';
const siteApi = nimblyCloudApi + '/sites';
const questionnaireApi = nimblyCloudApi + '/questionnaires';

const issuesApi = nimblyCloudApi + '/issues/issues';
const issuesAppEngineApi = nimblyCloudApi + '/app-engine/issues';
const issueMessageApi = nimblyCloudApi + '/issues/issueMessages';
const issuePdfApi = goApiUrl + '/v1/issue-pdf';

export const baseURL = cloudFunctionApi;
export const apiURL = nimblyCloudApi;
export const fmcgURL = fmcgCloudApi;
export const fmcgAuth = fmcgApiAuth;
export const apiURLAlt = nimblyCloudApiAlt;
export const cloudV2ApiURL = cloudV2Api;
export const appengineURL = nimblyAppengineURL;
export const returnToURL = nimblyReturnToURL;
export const dashboardID = nimblyDashboardID;
export const dashboardIDDemo = nimblyDashboardIDForDemo;
export const issueDashboardID = nimblyDashboardIDForIssueDashboard;
export const issueDashboardIDDemo = nimblyDashboardIDForIssueDashboardDemo;
export const prodOverviewDashboard = nimblyProdOverviewDashboard;
export const prodURL = nimblyProdURL;
export const prodIssueDashboard = nimblyProdIssueDashboard;
export const rankingDashboardID = nimblyRankingDashboard;
export const fnbInsightsDashboardID = nimblyfnbInsightsDashboard;
export const storePerformanceDashboardID = nimblyStorePerformance;
export const usersDashbaordID = nimblyUsersDashboardID;
export const prodUserDashboardID = nimblyProdUserDashboardID;
export const irfsatDashboardID = nimblyIRFSATDashboardID;
export const irfsatProdDashbaordID = nimbluIRFSATProdDashboardID;
export const stockAuditDashboardID = nimblyStockAuditDashbaordID;
export const prodStockAuditDashboardID = nimblyStockAuditProdDashboardID;
export const sitesDashboardID = nimblySitesDashboard;
export const jjSitesDashboardID = nimblyJJSitesDashboard;
export const sitesProdDashboardID = nimnlyProdSitesDashboard;
export const jjSitesProdDashboardID = nimnlyProdJJSitesDashboard;
export const npsDashboardID = nimblyNPSDashboard;
export const customerFeedbackDashboardID = nimblyCustomerFeedbackDashboard;
export const cfDashboardID = nimblyCustomerFeedbackDashboard;
export const adminDashboardID = nimblyLmsAdmin;
export const learnerDashboardID = nimblyLmsLearner;
export const instructorDashboardID = nimblyLmsInstructor;
export const adminProdDashboardID = nimblyProdLmsAdmin;
export const learnerProdDashboardID = nimblyProdLmsLearner;
export const instructorProdDashboardID = nimblyProdLmsInstructor;
export const metricsDashboardID = nimblyCustomerMetricsDashboard;
export const thaiDashboardID = nimblyThaiDashboardID;
const prodEnvUrl = nimblyProdEnv;
export const KFCOverviewDashboardID = nimblyKFCOverview;
export const KFCIssueDashboardID = nimblyKFCIssues;
export const KFCUserDashboardID = nimblyKFCUsers;
export const KFCSitesDashboardID = nimblyKFCSites;
export const KFCProdOverviewDashboardID = nimblyPRODKFCOverview;
export const KFCProdIssueDashboardID = nimblyPRODKFCIssues;
export const KFCProdUserDashboardID = nimblyPRODKFCUsers;
export const KFCProdSitesDashboardID = nimblyPRODKFCSites;
export const RMUOverviewDashboardID = nimblyRMUOverview;
export const RMUProdOverviewDashboardID = nimblyProdRMUOverview;
export const CEOPersonaDashboardID = nimblyCEOPersona;
export const CEOPersonaProdDashboardID = nimblyProdCEOPersona;
export const bulkOpsUrl = nimblyBulkOpsApiUrl;

export const NIMBLY_API_ISSUES_DETAIL = issuesApi + '/';
export const NIMBLY_API_ISSUES_DETAIL_V2 = `${issuesApi}/v2/`;
export const NIMBLY_API_ISSUES_LIST = issuesApi;
export const NIMBLY_API_ISSUES_LIST_V2 = NIMBLY_API_ISSUES_LIST + '/v2';
export const NIMBLY_API_ISSUES_LIST_V3 = NIMBLY_API_ISSUES_LIST + '/v3';
export const NIMBLY_API_ISSUES_CREATE = issuesApi + '/create';
export const NIMBLY_API_ISSUES_CREATE_V2 = NIMBLY_API_ISSUES_CREATE + '/v2';
export const NIMBLY_API_ISSUES_BULK_EDIT = issuesApi + '/bulkUpdate';
export const NIMBLY_API_ISSUES_BULK_MESSAGE = issueMessageApi + '/bulkCreate';
export const NIMBLY_API_ISSUES_UPDATE = issuesApi + '/update';
const NIMBLY_API_ISSUES_COMMENT = issueMessageApi + '/create';
export const NIMBLY_API_ISSUES_COMMENT_V2 = NIMBLY_API_ISSUES_COMMENT + '/v2';
const NIMBLY_API_ISSUES_UPLOAD_PHOTO = issueMessageApi + '/upload';
export const NIMBLY_API_ISSUES_CUSTOM_FILTER = nimblyCloudApi + '/issues/issue-tracker-filters';

// PDF API
export const GO_API_ISSUE_PDF = issuePdfApi;

// Department
export const NIMBLY_API_DEPARTMENT_LIST = departmentApi;

// Site
export const NIMBLY_API_SITE_LIST_COMPACT = siteApi + '/compact';

// User
export const NIMBLY_API_USER_LIST = userApi;

// Questionnaire
export const NIMBLY_API_QUESTIONNAIRE_QUESTION_CATEGORY_LIST = questionnaireApi + '/questioncategories';

export const NIMBLY_API_ATTACHMENT_THUMBNAIL = import.meta.env.REACT_APP_GALLERY_THUMBNAIL_URL;

export const GALLERY_API_URL = apiURLAlt + '/gallery/gallery';
export const GALLERY_V2_API_URL = apiURLAlt + '/gallery/gallery/v2';
export const GALLERY_DOWNLOAD_URL = GALLERY_API_URL + '/download';
export const GALLERY_DOWNLOAD_URL_V2 = GALLERY_V2_API_URL + '/download';
export const GALLERY_THUMBNAIL_URL = import.meta.env.REACT_APP_GALLERY_THUMBNAIL_URL;

export const FILE_REPO_API_URL = apiURLAlt + '/file-repo';

/** Reports Hub */

// Set Password Manager
export const NIMBLY_DYNAMIC_LINK_SET_PASSWORD = 'https://nimbly.page.link/set-auth';
export const NIMBLY_AUDIT_LINK = 'https://audit.hellonimbly.com/';

// CS-utility which is currently being deployed with nps
const NIMBLY_API_NPS_BASE = `${apiURL}/nps`;
export const NIMBLY_DELETE_MISSED_REPORT = `${NIMBLY_API_NPS_BASE}/deleteMissedReport`;
export const NIMBLY_FETCH_ALL_ORGSLIST = `${NIMBLY_API_NPS_BASE}/orgList`;
export const NIMBLY_FETCH_EXTERNAL_ORGSLIST = `${NIMBLY_API_NPS_BASE}/externalOrgList`;
export const NIMBLY_FETCH_SITES_WITH_DETAILS = `${NIMBLY_API_NPS_BASE}/siteQuestionnaireAuditorList`;
export const NIMBLY_CHANGE_USER_EMAIL = `${NIMBLY_API_NPS_BASE}/changeEmailAddress`;
export const bulkUploadScheduleTemplate = UploadScheduleTemplate;
export const bulkCreateQuizTemplate = CreateQuizTemplate;
export const bulkReportDownloadURL = reportBulkDownload;
export const bulkUploadTemplateURL = nimblyBulkUploadTemplate;

/** Site Groups */
export const SITE_GROUPS_BASE_URL = `${apiURL}/sites/group`;

/** Vertex AI */
export const COMMENT_TRANSLATION_API = `${apiURL}/vertex-ai/translation/v1`;
